export const addFile = (roomFile) =>
	({
		type: 'ADD_FILE',
		payload: { roomFile }
	});

export const setFileHistory = (fileHistory) =>
	({
		type: 'SET_FILE_HISTORY',
		payload: { fileHistory }
	});

export const setFileProgress = (filepath, progress) =>
	({
		type: 'SET_FILE_PROGRESS',
		payload: { filepath, progress }
	});

export const deleteFile = (id) =>
	({
		type: 'DELETE_FILE',
		payload: { id }
	});

export const clearFiles = () =>
	({
		type: 'CLEAR_FILES'
	});